/**
 *
 * @author Matthew Rawson @ 13/09/2018 11:46
 * @description
 * @notes
 */
import React, {PureComponent} from "react"
import PropTypes from "prop-types"
import {get} from "lodash"

import id from "@irati/utils/id"
import {FormattedMessage} from "@irati/utils/lang"
import {ButtonLink} from "@irati/ui/src/Link"
import {COMPLETE} from "@irati/insights/constants/report"


class ReportActionCellRenderer extends PureComponent {
  static propTypes = {
    row: PropTypes.object
  }
  static defaultProps = {
    row: {}
  }


  constructor(props) {
    super(props)
    this.state = {}
  }


  render() {
    const idNamespace = id("ReportActionCellRenderer", this.props)
    const {row} = this.props
    const isComplete = get(row, "_original.status") === COMPLETE
    const fileUrl = get(row, "_original.resultFileUrl")

    if (!isComplete || !fileUrl) return null

    return (
      <ButtonLink primary id={id("report-link", idNamespace)} href={fileUrl} target="_BLANK">
        <FormattedMessage id="insights.reports.list.viewPdfReport" />
      </ButtonLink>
    )
  }
}

export default ReportActionCellRenderer
